import React from 'react'
import defaultImg from "../assets/images/alberi.webp"


function Hero({children, img, overlay, height}) {
    let image = img ? img: defaultImg;
    return (
        <div style={ 
            {
            background: `url(${image})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            height: height ? height : "auto",
            }
        }>
            <div className={overlay? 'hero-overlay' : ""}>
                <div className="hero-container">
                    {children}
                </div>
            </div>
            
        </div>
    )
}

export default Hero
